<template>

    <div style="display: flex;justify-content: space-between; flex-wrap: wrap; gap: 8px">
      <div>
        <el-button type="primary" :disabled="loading" @click="openDialog">选图</el-button>
        <el-button :disabled="loading" @click="openSourceMapDialog" style="margin-left: 4px">用户来源映射</el-button>
        <el-select placeholder="新建国家分组" style="margin-left: 4px" :disabled="loading" @change="addCountry" filterable>
          <el-option v-for="c in $root.country_list" :value="c.code" :disabled="countries.includes(c.code)"
                     :label="c.en_name + ' (' + c.code + ')'"></el-option>
        </el-select>
      </div>
      <div style="display: flex; flex-wrap: wrap; gap: 4px; align-items: center">
        <el-select v-model="form.platform" :disabled="loading" @change="formatData" placeholder="平台" filterable
                   clearable style="width: 150px">
          <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>
        </el-select>
        <el-select v-model="form.country" :disabled="loading" @change="formatData" placeholder="全球" style="width: 150px">
          <el-option value="GLOBAL" label="GLOBAL"></el-option>
          <el-option v-for="c in countries" :value="c" :label="c"></el-option>
        </el-select>
        <el-select ref="sourceSelect" v-model="form.source" :disabled="loading" filterable clearable
                   @change="onSourceChange" style="width: 240px" placeholder="默认用户来源">
          <el-option :value="''" label="默认用户来源"></el-option>
          <el-option v-for="s in namedSources" :key="s" :value="s" :label="s"></el-option>
          <template #footer>
            <div style="padding: 6px 12px; border-top: 1px solid var(--el-border-color-lighter)">
              <el-button link :disabled="loading" @click="promptCreateSource">新建用户来源</el-button>
            </div>
          </template>
        </el-select>
        <el-button v-if="!isDefaultSource" type="danger" plain :disabled="loading" @click="deleteSource">删除用户来源</el-button>
        <el-select v-model="form.label" :disabled="loading" @change="formatData" style="width: 140px">
          <el-option v-for="l in labels" :value="l" :label="`方案${l}`"></el-option>
        </el-select>
        <el-button v-if="has_feature_rookie_apply" type="danger" :disabled="loading" @click="openCopySourceDialog">复制完整用户来源方案</el-button>
        <el-button v-if="has_feature_rookie_apply" type="danger" :disabled="loading" @click="openCopyLabelDialog">复制当前方案</el-button>
      </div>
    </div>

    <template v-for="d in data">
        <el-card style="margin-top: 5px" shadow="never" :header="`第${d.day}天`" v-if="d" v-loading="loading">
            <vue-draggable-next v-model="d.images" :animation="300" handle=".handle" @change="resort(d.images)">
                <template v-for="rookie in d.images">
                    <div class="handle" style="display: inline-block;position: relative; text-align: center; vertical-align: top">
                        <el-image style="margin: 5px 5px 0;height: 160px"
                                  :src="`${get_image_cdn_url(rookie.thumbnail)}`"></el-image>
                        <el-icon @click="remove(rookie)"
                                 style="position: absolute; top: 5px; right: 5px; cursor: pointer">
                            <CircleClose/>
                        </el-icon>
                        <div style="font-size: 12px; line-height: 18px; color: var(--el-text-color-regular); margin-bottom: 4px">
                          {{ rookie.nickname }}
                        </div>
                    </div>
                </template>
            </vue-draggable-next>
        </el-card>
    </template>
    <el-table style="margin-top: 10px" v-loading="loading" :data="rookieFilter">
      <el-table-column label="预览图" prop="prefix" width="230">
        <template #default="scope">
          <el-image lazy :src="`${get_image_cdn_url(scope.row.thumbnail)}`"
                    style="width: 150px"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="ID" prop="image_id" width="180"></el-table-column>
      <el-table-column label="nickname" prop="nickname" width="100"></el-table-column>
      <el-table-column label="激励视频" width="150">
        <template #default="scope">
          <el-tag v-if="scope.row.video">{{"Yes"}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="天数" prop="day" width="180">
        <template #default="scope">
          <el-input-number v-model="scope.row.day" :disabled="loading"  @change="updateRookie(scope.row, true)"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="上线时间" prop="online_date" width="200"></el-table-column>
    </el-table>
    <el-dialog v-model="dialog_opened" :before-close="reset" width="80%">
        <el-form :model="form" label-width="100px" ref="form">
            <el-form-item label="天数" prop="day" :rules="[{required: true, message: '输入天数', type: 'number'}]">
                <el-input-number v-model="form.day" :disabled="loading"></el-input-number>
            </el-form-item>
            <el-form-item label="图片" prop="images" :rules="[{required: true, message: '请选择图片'}]">
              <template v-for="image in form.images">
                <el-image style="width: 160px" :src="`${get_image_cdn_url(image.thumbnail)}`"></el-image>
              </template>
            </el-form-item>
        </el-form>
        <div>
          <el-select :disabled="loading" v-model="query.category" clearable filterable style="width: 200px"
                     placeholder="分类">
            <el-option v-for="c in category_list" :label="`${c.i18n_name.EN}(${c.i18n_name.ZH_HANS})`"
                       :value="c.id"></el-option>
          </el-select>
          <el-select :disabled="loading" v-model="query.video" clearable style="width: 100px" placeholder="激励视频">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
          <el-select :disabled="loading" v-model="query.online" clearable style="width: 200px" placeholder="已上线图片">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
          <el-input v-model="query.nickname" placeholder="nickname" clearable style="width: 120px"></el-input>
          <el-input v-model="query.id" placeholder="ID" style="width: 220px"></el-input>
          <el-button type="success" :loading="loading" @click="fetchImages(1)">查询</el-button>
        </div>
        <el-table :data="image_list" v-loading="loading" style="margin-top: 10px">
            <el-table-column label="预览图" prop="prefix" width="230">
                <template #default="scope">
                    <el-image lazy :src="`${get_image_cdn_url(scope.row.thumbnail)}`"
                              style="width: 100px"></el-image>
                    <el-image lazy :src="`${get_image_cdn_url(scope.row.finished)}`"
                              style="width: 100px"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="id" prop="nickname" width="100"></el-table-column>
            <el-table-column label="类型" prop="type" width="60">
                <template #default="scope">
                    {{ image_type_enum[scope.row.type] }}
                </template>
            </el-table-column>
            <el-table-column label="色块" prop="cells" width="60"></el-table-column>
            <el-table-column label="难度" prop="difficulty" width="60">
                <template #default="scope">
                    <div v-if="scope.row.cells" :style="{color: scope.row.difficulty?'var(--el-color-error)':null}">
                        L{{ scope.row.cells > 800 ? 4 : scope.row.cells > 500 ? 3 : scope.row.cells > 300 ? 2 : 1 }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="激励视频" width="100">
              <template #default="scope">
                <el-tag v-if="scope.row.video" size="small">{{ 'Yes' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="分类" prop="categories" width="60">
                <template #default="scope">
                    <template v-for="c in scope.row.categories">
                        <template v-for="cc in category_list">
                            <el-tag size="small" v-if="cc.id===c">{{ cc.i18n_name.EN }}</el-tag>
                        </template>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="作者" prop="authors" width="100"></el-table-column>
            <el-table-column label="操作" width="100">
                <template #default="scope">
                  <el-button type="primary" @click="addImage(scope.row)" size="small" :disabled="loading || scope.row.added">
                    {{ scope.row.added ? '已添加' : '添加' }} </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" :total="total" @current-change="fetchImages"
                       :page-size="query.limit"></el-pagination>
        <template #footer>
            <el-button type="primary" :loading="loading" @click="reset" text>取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
        </template>
    </el-dialog>
    <el-dialog v-model="dialog_copy_source" width="30%" title="复制完整用户来源方案">
      <el-form label-width="140px">
        <el-form-item label="当前用户来源">
          <span>{{ form.source || '默认用户来源' }}</span>
        </el-form-item>
        <el-form-item label="目标用户来源">
          <el-select v-model="form.target_source" :disabled="loading" filterable allow-create clearable
                     default-first-option placeholder="默认用户来源" style="width: 100%">
            <el-option :value="''" label="默认用户来源"></el-option>
            <el-option v-for="s in namedSources" :key="s" :value="s" :label="s"
                       :disabled="isSameAsCurrentSource(s)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标国家">
          <el-select v-model="form.target_country" :disabled="loading" placeholder="全球" filterable style="width: 100%">
            <el-option value="GLOBAL" label="GLOBAL"></el-option>
            <el-option v-for="c in countries" :value="c" :label="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标平台">
          <el-select v-model="form.target_platform" :disabled="loading" placeholder="Android" filterable style="width: 100%">
            <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>
          </el-select>
        </el-form-item>
        <div style="color: var(--el-text-color-secondary); font-size: 12px; padding-left: 140px">
          将复制当前用户来源下方案 0/1/2 的全部新手图到目标用户来源
        </div>
      </el-form>
      <el-row style="justify-content: flex-end; margin-top: 10px">
        <el-button @click="reset()" :loading="loading">取消</el-button>
        <el-button @click="copyRookieSource()" type="primary" :loading="loading">确认</el-button>
      </el-row>
    </el-dialog>
    <el-dialog v-model="dialog_copy_label" width="30%" title="复制当前方案">
      <el-form label-width="140px">
        <el-form-item label="目标方案">
          <el-checkbox-group v-model="form.target_labels" :disabled="loading">
            <el-checkbox v-for="i in labels" :key="i" :label="i">{{ `方案${i}` }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="目标用户来源">
          <el-select v-model="form.target_source" :disabled="loading" filterable allow-create clearable
                     default-first-option placeholder="默认用户来源" style="width: 100%">
            <el-option :value="''" label="默认用户来源"></el-option>
            <el-option v-for="s in namedSources" :key="s" :value="s" :label="s"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标国家">
          <el-select v-model="form.target_country" :disabled="loading" placeholder="全球" filterable style="width: 100%">
            <el-option value="GLOBAL" label="GLOBAL"></el-option>
            <el-option v-for="c in countries" :value="c" :label="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标平台">
          <el-select v-model="form.target_platform" :disabled="loading" placeholder="Android" filterable style="width: 100%">
            <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-row style="justify-content: flex-end; margin-top: 10px">
        <el-button @click="reset()" :loading="loading">取消</el-button>
        <el-button @click="copyRookieLabel()" type="primary" :loading="loading">确认</el-button>
      </el-row>
    </el-dialog>
    <el-dialog v-model="dialog_source_map" width="640px" title="用户来源映射" @open="fetchSourceMaps">
      <div style="color: var(--el-text-color-secondary); font-size: 12px; margin-bottom: 12px">
        将 MMP 的 campaign / adset 映射到 Rookie 用户来源；多个 key 可指向同一来源。
      </div>
      <el-form :inline="true" @submit.prevent>
        <el-form-item label="广告 key">
          <el-input v-model="source_map_form.key" :disabled="loading" placeholder="campaign 或 adset"
                    style="width: 180px" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户来源">
          <el-select v-model="source_map_form.source" :disabled="loading" filterable allow-create
                     default-first-option clearable placeholder="选择或输入" style="width: 180px">
            <el-option v-for="s in namedSources" :key="s" :value="s" :label="s"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="loading" @click="upsertSourceMap">添加 / 更新</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="source_maps" v-loading="loading" size="small" style="width: 100%">
        <el-table-column prop="key" label="广告 key (campaign/adset)" min-width="200"></el-table-column>
        <el-table-column prop="source" label="用户来源" min-width="160"></el-table-column>
        <el-table-column label="操作" width="90">
          <template #default="scope">
            <el-button link type="danger" :disabled="loading" @click="deleteSourceMap(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="dialog_source_map = false" :loading="loading">关闭</el-button>
      </template>
    </el-dialog>
</template>

<script>
import axios from "ts-axios-new";
import {VueDraggableNext} from 'vue-draggable-next'
import {ElMessage, ElMessageBox} from 'element-plus'
import {has_feature_rookie_apply} from "../libs/permission";
import {get_image_cdn_url} from "../libs/app";

const EMPTY_SOURCE_KEY = ''

function normalizeSource(source) {
  if (source == null || source === '' || String(source).toLowerCase() === 'default') {
    return EMPTY_SOURCE_KEY
  }
  return String(source)
}

function apiSource(source) {
  const n = normalizeSource(source)
  return n === EMPTY_SOURCE_KEY ? null : n
}

function sameSourceBucket(rowSource, selected) {
  return normalizeSource(rowSource) === normalizeSource(selected)
}

export default {
    name: "Rookie",
    components: {VueDraggableNext},
    data() {
        return {
            loading: false, data: [], labels: [0, 1, 2], image_list: [], category_list: [],
            dialog_opened: false, rookie: [], countries: [],
            dialog_copy_source: false,
            dialog_copy_label: false,
            dialog_source_map: false,
            source_maps: [],
            source_map_form: {key: '', source: ''},
            total: 0, page: 1, rookie_set: new Set(),
            local_sources: [],
            image_type_enum: {1: '单色', 2: '彩绘'},
            form: {
              label: 0,
              day: 0,
              images: [],
              country: "GLOBAL",
              platform: "android",
              source: '',
              target_labels: [0, 1, 2],
              target_source: '',
              target_country: null,
              target_platform: null,
            },
            query: {
              module: 1,
              online: true,
              skip: 0,
              limit: 10,
              video: null,
              category: null,
              nickname: null,
              id: null,
            },
        }
    },
    methods: {
      get_image_cdn_url,
      has_feature_rookie_apply,
        isSameAsCurrentSource(s) {
          return normalizeSource(s) === normalizeSource(this.form.source);
        },
        init() {
            this.loading = true;
            axios.get(`/cms/v1/rookie`).then(res => {
                this.rookie = res.data.data.imageList;
            }).then(_ => {
                this.loading = false;
                this.formatData();
                this.refreshAdded();
            })
        },
        openDialog() {
            this.dialog_opened = true;
            this.form.images = []
            this.form.day = 0
            this.query.id = '';
            this.fetchImages(1);
        },
        fetchImages(page) {
          this.query.skip = (page - 1) * this.query.limit;
          this.page = page
          this.loading = true;
          axios.get(`/cms/v1/image`, {params: this.query}).then(res => {
            this.image_list = res.data.data.imageList;
            this.total = res.data.data.total;
            this.loading = false;
            this.refreshAdded();
          })
        },
        openCopySourceDialog() {
          this.dialog_copy_source = true;
          this.form.target_source = '';
          this.form.target_country = this.form.country;
          this.form.target_platform = this.form.platform;
        },
        openCopyLabelDialog() {
          this.dialog_copy_label = true;
          this.form.target_labels = [0, 1, 2];
          this.form.target_source = this.form.source || '';
          this.form.target_country = this.form.country;
          this.form.target_platform = this.form.platform;
        },
        openSourceMapDialog() {
          this.dialog_source_map = true;
          this.source_map_form = {key: '', source: ''};
        },
        fetchSourceMaps() {
          this.loading = true;
          axios.get('/cms/v1/rookie/source-map').then(res => {
            this.source_maps = res.data.data.mapList || [];
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        },
        upsertSourceMap() {
          const key = String(this.source_map_form.key || '').trim();
          const source = String(this.source_map_form.source || '').trim();
          if (!key) {
            ElMessage.warning('请输入广告 key');
            return;
          }
          if (!source || source.toLowerCase() === 'default') {
            ElMessage.warning('请选择或输入非默认用户来源');
            return;
          }
          this.loading = true;
          axios.post('/cms/v1/rookie/source-map', {key, source}).then(() => {
            if (!this.local_sources.includes(source) && !this.namedSources.includes(source)) {
              this.local_sources.push(source);
            }
            this.source_map_form = {key: '', source: ''};
            this.fetchSourceMaps();
          }).catch(() => {
            this.loading = false;
          });
        },
        deleteSourceMap(row) {
          if (!row || !row.id) return;
          ElMessageBox.confirm(`确认删除映射「${row.key} → ${row.source}」？`, '删除映射', {type: 'warning'})
            .then(() => {
              this.loading = true;
              return axios.delete(`/cms/v1/rookie/source-map/${row.id}`);
            })
            .then(() => this.fetchSourceMaps())
            .catch(() => {
              this.loading = false;
            });
        },
        onSourceChange(val) {
          const key = String(val == null ? '' : val).trim();
          if (!key || key.toLowerCase() === 'default') {
            this.form.source = '';
          } else {
            this.form.source = key;
          }
          this.formatData();
        },
        promptCreateSource() {
          if (this.$refs.sourceSelect) {
            this.$refs.sourceSelect.blur();
          }
          ElMessageBox.prompt('请输入用户的广告来源', '新建用户来源', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /\S+/,
            inputErrorMessage: '不能为空',
            inputPlaceholder: '如 campaign_a',
          }).then(({value}) => {
            const key = String(value || '').trim();
            if (!key || key.toLowerCase() === 'default') {
              ElMessage.warning('请输入非空的用户来源');
              return;
            }
            if (this.namedSources.includes(key) || this.local_sources.includes(key)) {
              ElMessage.warning(`用户来源「${key}」已存在`);
              return;
            }
            this.local_sources.push(key);
            this.form.source = key;
            this.formatData();
          }).catch(() => {});
        },
        deleteSource() {
          const source = apiSource(this.form.source);
          if (!source) {
            ElMessage.warning('不能删除默认用户来源');
            return;
          }
          ElMessageBox.confirm(`确认删除用户来源「${source}」在当前国家/平台下方案 0/1/2 的全部新手图？`, '删除用户来源', {type: 'warning'})
            .then(() => {
              this.loading = true;
              return axios.post('/cms/v1/rookie/delete-source', {
                country: this.form.country,
                platform: this.form.platform,
                source,
              });
            })
            .then(() => {
              this.local_sources = this.local_sources.filter(k => k !== source);
              this.form.source = '';
              this.init();
            })
            .catch(() => {
              this.loading = false;
            });
        },
        formatData() {
          this.data = [];
          this.rookie_set = new Set()
          this.rookie.forEach(r => {
            if (!r.label) {
              r.label = 0
            }
            if (!r.platform) {
              r.platform = "android"
            }
            if (!r.country) {
              r.country = "GLOBAL"
            }
            if (!this.countries.includes(r.country) && r.country !== "GLOBAL") {
              this.countries.push(r.country);
            }
            if (r.label === this.form.label && r.country === this.form.country && r.platform === this.form.platform
                && sameSourceBucket(r.source, this.form.source)) {
              this.rookie_set.add(r.image_id)
              if (!this.data[r.day]) {
                this.data[r.day] = {day: r.day, images: []}
              }
              this.data[r.day].images.push(r);
            }
          });
          this.data.forEach(d => {
            d.images.sort(function (a, b) {
              return a.sort - b.sort;
            })
          })
        },
        refreshAdded() {
          this.image_list.forEach(image => {
            image.added = false;
          });
          this.image_list.forEach(image => {
            image.added = this.rookie_set.has(image.id);
          });
        },
        reset() {
            if(this.$refs.form) {
              this.$refs.form.resetFields();
            }
            this.form.images = [];
            this.dialog_opened = this.dialog_copy_source = this.dialog_copy_label = this.loading = false;
            this.refreshAdded()
        },
        submit() {
            this.$refs.form.validate(valid => {
              if (valid) {
                this.loading = true;
                const reqs = [];
                const source = apiSource(this.form.source);
                this.form.images.forEach(i => {
                  const data = {day: this.form.day, label: this.form.label, country: this.form.country, image_id: i.id,
                    platform: this.form.platform};
                  if (source) {
                    data.source = source;
                  }
                  reqs.push(axios.post(`/cms/v1/rookie`, data).then(res => {
                    this.rookie.push(res.data.data);
                  }));
                });
                axios.all(reqs).then(_ => {
                  this.init();
                  this.reset();
                }).catch(() => {
                  this.loading = false;
                })
              }
            })
        },
        remove(row) {
            this.loading = true;
            axios.delete(`/cms/v1/rookie/${row.id}`).then(res => {
                this.init()
            });
        },
        addImage(image) {
          image.added = true
          this.form.images.push(image);
        },
        resort(images) {
          const sort = [];
          images.forEach(i => {
            sort.push(i.id);
          });
          this.loading = true;
          axios.post(`/cms/v1/sort/rookie`, {sort}).then(res => {
            this.loading = false;
            this.init()
          })
        },
        updateRookie(row, refresh) {
          if(refresh) {
            this.loading = true;
          }
          const source = apiSource(this.form.source);
          axios.put(`/cms/v1/rookie`, {
            image_id: row.image_id, day: row.day, platform: this.form.platform,
            label: this.form.label, country: this.form.country,
            source,
          }).then(_ => {
            if(refresh) {
              this.loading = false
              this.init();
            }
          })
        },
        copyRookieSource() {
          const source = apiSource(this.form.source);
          const targetSource = apiSource(this.form.target_source);
          if (normalizeSource(this.form.source) === normalizeSource(this.form.target_source)
              && this.form.target_country === this.form.country
              && this.form.target_platform === this.form.platform) {
            ElMessage.warning('目标和当前用户来源相同');
            return;
          }
          this.loading = true;
          const body = {
            country: this.form.country,
            platform: this.form.platform,
            target_country: this.form.target_country,
            target_platform: this.form.target_platform,
          };
          if (source) body.source = source;
          if (targetSource) body.target_source = targetSource;
          axios.post(`/cms/v1/copy/rookie/source`, body).then(_ => {
            if (targetSource && !this.local_sources.includes(targetSource)
                && !this.namedSources.includes(targetSource)) {
              this.local_sources.push(targetSource);
            }
            this.init();
            this.reset();
          }).catch(() => {
            this.loading = false;
          });
        },
        copyRookieLabel() {
          if (!this.form.target_labels || !this.form.target_labels.length) {
            ElMessage.warning('请选择目标方案');
            return;
          }
          this.loading = true;
          const source = apiSource(this.form.source);
          const targetSource = apiSource(this.form.target_source);
          const body = {
            label: this.form.label,
            country: this.form.country,
            platform: this.form.platform,
            target_labels: this.form.target_labels.join(','),
            target_country: this.form.target_country,
            target_platform: this.form.target_platform,
          };
          if (source) body.source = source;
          if (targetSource) body.target_source = targetSource;
          axios.post(`/cms/v1/copy/rookie/label`, body).then(_ => {
            if (targetSource && !this.local_sources.includes(targetSource)
                && !this.namedSources.includes(targetSource)) {
              this.local_sources.push(targetSource);
            }
            this.init();
            this.reset();
          }).catch(() => {
            this.loading = false;
          });
        },
        addCountry(country) {
          if (country && !this.countries.includes(country)) {
            this.countries.push(country);
            this.form.country = country;
            this.data = [];
          }
        }
    },
    mounted() {
        this.loading = true;
        axios.get('/cms/v1/category').then(res => {
            this.category_list = res.data.data.categoryList;
        }).then(_ => {
            this.loading = false;
            this.init();
        })
    },
    computed: {
      isDefaultSource() {
        return normalizeSource(this.form.source) === EMPTY_SOURCE_KEY;
      },
      namedSources() {
        const fromData = new Set();
        this.rookie.forEach(r => {
          const sk = normalizeSource(r.source);
          if (sk !== EMPTY_SOURCE_KEY && (r.label || 0) === this.form.label) {
            fromData.add(sk);
          }
        });
        this.local_sources.forEach(k => fromData.add(k));
        return Array.from(fromData).sort();
      },
      rookieFilter() {
          return this.rookie.filter(d => {
            if (!d.label) {
              d.label = 0
            }
            return d.label === this.form.label && d.country === this.form.country && d.platform === this.form.platform
              && sameSourceBucket(d.source, this.form.source);
          })
        },
    }
}
</script>

<style scoped>

.el-select {
  width: 200px;
}
</style>
